import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import MCustomScrollbar from "@/components/MCustomScrollbar";
import PageContent from "@/components/PageContent";
import Panel from "@/components/Panel";
import JcDialog from "@/components/JcDialog";

import CTable from "@/components/Tables/CTable";

import CInput from "@/components/Forms/CInput";
import CFormGroup from "@/components/Forms/CFormGroup";
import CForm from "@/components/Forms/CForm";
import CCheckbox from "@/components/Forms/CCheckbox";
import CSelect2 from "@/components/Forms/CSelect2";
import CDatePicker from "@/components/Forms/CDatePicker";
import CInputTag from "@/components/Forms/CInputTag";

export default {
  install(Vue) {

    Vue.component("vue-perfect-scrollbar", VuePerfectScrollbar);
    Vue.component(MCustomScrollbar.name, MCustomScrollbar);
    Vue.component(PageContent.name, PageContent);
    Vue.component(Panel.name, Panel);
    Vue.component(JcDialog.name, JcDialog);

    Vue.component(CTable.name, CTable);

    Vue.component(CFormGroup.name, CFormGroup);
    Vue.component(CInput.name, CInput);
    Vue.component(CForm.name, CForm);
    Vue.component(CCheckbox.name, CCheckbox);
    Vue.component(CSelect2.name, CSelect2);
    Vue.component(CDatePicker.name, CDatePicker);
    Vue.component(CInputTag.name, CInputTag);

  }
}